import { render } from "./CurrentUserPane.vue?vue&type=template&id=019a1b5a&scoped=true"
import script from "./CurrentUserPane.vue?vue&type=script&lang=js"
export * from "./CurrentUserPane.vue?vue&type=script&lang=js"

import "./CurrentUserPane.vue?vue&type=style&index=0&id=019a1b5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019a1b5a"]])

export default __exports__